import color from '../../text/color';

const secondary = (params) => color(params);

export default secondary;
